<template>
  <div
    class="table-saved-filters f-column"
    data-tst="table_saved_filters"
  >
    <GwFilter
      v-if="!tcrud_trulySelectedItems.length"
      :asRow="true"
      :hasSaveBtn="false"
      :hasClearBtn="false"
      filterUrlPrefix="ffsf"
      filterConfigKey="savedFilters"
      style="margin-right: 2rem"
    />

    <TableDeleteBtns
      v-else
      class="mt-2"
      @confirm="tcrud_singleDeleteSelectedItems"
      @close="tcrud_resetSelectedRows()"
    />

    <TableBody
      ref="tablebody"
      class="mt-2"
      :items="tcrud_items"
      :loading="tcrud_loading"
      :error="tcrud_error"
      :isInfinite="true"
      size="small"
    >
      <template #no_data>
        <div
          class="gw_box flex-1 f-center f-column"
          style="--clr-box-back: var(--clr-black-0-3)"
        >
          <IconAndText
            v-if="filter.active"
            icon="mdi-filter"
            :title="$t('data_table.saved_filters_table.no_filters')"
            :subtitle="$t('data_table.saved_filters_table.no_data_change_filter_tra01')"
          />
          <IconAndText
            v-else
            icon="mdi-folder"
            :title="$t('data_table.saved_filters_table.no_filters')"
            :subtitle="$t('data_table.saved_filters_table.save_filters')"
          />
        </div>
      </template>
      <template #head_before>
        <TableHead
          v-if="tcrud_items.length"
          :sortConf="tbl_sortConf"
          :thead="thead"
          @click:th="tbl_handleSort"
        >
          <template #th_before>
            <TableHeadCell
              :sortConf="tbl_sortConf"
              class="f-center gw_table_head_cell_sort_icon_visible"
              style="
                --max-width-th: 2.5rem;
                --min-width-th: 2.5rem;
                --inset-sort-icon: auto;
                --padding-sortable-th: 0;
              "
              :item="{ sortKey: 'ordering_position' }"
              @click="tbl_handleSort"
            >
              <template #sort_icon>
                <div
                  class="gw_table_head_cell_sort_icon mdi mdi-drag-vertical csst csst_nm pa-1"
                  style="font-size: 1rem"
                ></div>
              </template>
            </TableHeadCell>
            <TableHeadCell
              class="f-center"
              style="
                --max-width-th: 2.5rem;
                --min-width-th: 2.5rem;
                --padding-th: 0;
                --overflow-th: none;
                border-top-left-radius: 4px;
              "
            >
              <TableMainCheckbox
                style="font-size: 1rem"
                :indeterminate="tcrud_mainCheckboxValue === 'indeterminate'"
                :value="tcrud_mainCheckboxValue === 'all'"
                @click="tcrud_toggleSelectedAll"
              />
            </TableHeadCell>
          </template>
        </TableHead>
      </template>
      <template #default="{ item, index }">
        <!-- :isActive="fss_selected_filter.id === item.id" -->
        <SavedFiltersTableV2Row
          :thead="thead"
          :item="item"
          :isSelected="!!tcrud_selectedItems[index]"
          :mobile="mobile"
          :allTags="allTags"
          tagType="saved_filters"
          :index="index"
          :draggedItems="tcrud_draggedItems"
          :dragDisabled="tbl_sortConf.sortKey !== 'ordering_position'"
          @toggle:selected="tcrud_toggleSelected(item, index, tcrud_items)"
          @apply:filter="applyFilter(item)"
          @click:tag_item="tag => tcrud_handleTagClick({ item, tag })"
          @drag:start="e => tcrud_handleDragstart({ e, item })"
          @patch:name="({ name }) => patchName({ item, name })"
          @open:detail="
            () => {
              detailItem = (detailItem ? detailItem.id : '') === item.id ? null : item
            }
          "
        >
        </SavedFiltersTableV2Row>
        <SavedFiltersTableV1RowDetail
          v-if="detailItem && detailItem.id === item.id"
          :text="item.description || ''"
          @update:text="text => patchDescription({ item, description: text })"
        />
      </template>
    </TableBody>

    <DragDropHandler
      ref="dragdrophandler"
      :getIndicatorStyle="tcrud_getDragIndicatorStyle"
      :proccessEvent="tcrud_scrollTable"
      dropTargetIdPart="saved-filters_table_row"
      @drag:drop="tcrud_handleDragdrop"
    >
      <template #shallowitem>
        <div
          class="gw_box"
          style="--clr-box-back: var(--clr-primary)"
        >
          <div
            v-if="tcrud_draggedItems.length > 1"
            class="truncate"
          >
            {{
              $t('common.xxx_selected_items', {
                num: tcrud_draggedItems.length,
              })
            }}
          </div>
          <div v-else-if="tcrud_draggedItem">
            {{ tcrud_draggedItem.name }}
          </div>
        </div>
      </template>
    </DragDropHandler>
  </div>
</template>

<script>
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import TableDeleteBtns from '@/components/DataTables/TableDeleteBtns'
import GwFilter from '@/components/DataTables/Filters/new/GwFilter'
import { getTagFilteredTableData } from '@/store/tableFilters/tableFilters'
import TableHead from '@/components/DataTables/v2/TableHead'
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'
import TableBody from '@/components/DataTables/v2/TableBody'
import SavedFiltersTableV2Row from '@/components/DataTables/v2/tables/SavedFiltersTableV2/SavedFiltersTableV2Row'
import SavedFiltersTableV1RowDetail from '@/components/DataTables/v2/tables/SavedFiltersTableV2/SavedFiltersTableV1RowDetail'
import DragDropHandler from '@/components/lib/DragDropHandler'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import tcrud_mix from '@/components/DataTables/tcrud_mix'
import { getLocalFiltersConfigs } from '@/components/DataTables/Filters/new/filter_helpers'

export default {
  name: 'SavedFiltersTableV2',

  components: {
    TableHead,
    TableHeadCell,
    TableBody,
    SavedFiltersTableV2Row,
    DragDropHandler,
    SavedFiltersTableV1RowDetail,
    IconAndText,
    TableDeleteBtns,
    GwFilter,
  },
  mixins: [tcrud_mix, table_mix, float_mix],
  props: {
    savedFilterUrlPrefix: { String, required: true },
    hasUrlUpdate: { type: Boolean, default: true },
    filterConfigKey: { type: String, default: 'savedFilters' },
  },
  emits: ['close', 'loaded'],
  data() {
    // this.sitesOptions = allSitesOptions()
    this.tcrud_conf = {
      getEndpoint: item => `poker/saved-filters/${item.id}/`,
      getDeleteEndpoint: item => `poker/saved-filters/${item.id}/`,
      deleteSuccessMessage: 'messages.sucess_deleting_filters',
      deleteErrorMessage: 'messages.error_deleting_filters',
      idKey: 'id',
    }

    this.tbl_persistSortKey = 'savedfilters_sort'
    this.tcrud_endpoint = 'poker/saved-filters/'
    this.tcrud_mutation = 'api_poker_saved_filters'
    this.tcrud_apiVersion = 'v1'
    return {
      tbl_sortConf: {
        sortKey: 'name',
        sortOrder: 'desc',
      },
      selectedRows: [],
      lastTouchedIdx: -1,

      detailItem: null,
      // tcrud_limit: 9999,
      // tcrud_offset: 0,
    }
  },
  created() {
    this.tbl_setSortConf()
    this.tcrud_getDataCheck() // is filtered locally
  },
  methods: {
    patchName({ item, name }) {
      const expected_item = {
        ...item,
        name,
      }
      this.tcrud_patchItem({
        item,
        patchData: { name },
        expected_item,
      })
    },
    patchDescription({ item, description }) {
      const expected_item = {
        ...item,
        description,
      }
      this.tcrud_patchItem({
        item,
        patchData: { description },
        expected_item,
      })
      this.detailItem = null
    },
    applyFilter(item) {
      const filter = item.settings

      let query = Object.keys(filter).reduce(
        (a, key) => ({
          ...a, //
          [`${this.savedFilterUrlPrefix}_${key}`]: [filter[key]].flat().join(','),
        }),
        {},
      )
      const unrelatedQuery = Object.keys(this.$route.query).reduce(
        (a, key) =>
          !key.startsWith(this.savedFilterUrlPrefix) ? { ...a, [key]: this.$route.query[key] } : a,
        {},
      )
      query = {
        ...unrelatedQuery,
        ...query,
      }

      if (this.hasUrlUpdate) {
        this.$router.push({ query }).catch(() => {})
      } else {
        const filterConfig = getLocalFiltersConfigs()[this.filterConfigKey]
        const filterConf = {
          loaded: true,
          data: filterConfig,
          // TODO NewFilters
          // apiTransform is ommited here so it wont work with tags_anyall - but so far we dont have this situation
          // this could be solve if login from GwFilterBody was as standalone set of js functions then it could be
          // recomputed here on the fly
          // it would also be good to have filterConfigKey and filterUrlPrefix unified under filterConfigKey/filterId
          params: filter,
          filter,
          active: Object.keys(filter || {}).length > 0,
        }
        this.$store.commit('filters_set', {
          key: this.savedFilterUrlPrefix,
          value: filterConf,
        })
      }

      // closing this prematurelly kills router update proccess
      setTimeout(() => {
        this.$emit('close')
      })
    },
  },
  computed: {
    allTags() {
      return this.$store.getters.tags_get_all_tags('saved_filters')
    },
    thead() {
      const cols = {
        // name_description: {
        name: {
          // name: this.$t('table_head.name_description'),
          name: this.$t('table_head.name'),
          sortKey: 'name',
          width: 16,
        },
        note: {
          // name: this.$t('table_head.name_description'),
          name: this.$t('table_head.note'),
          sortKey: 'name',
          width: 16,
        },
        tags: {
          name: this.$t('table_head.tags'),
          width: 13,
        },
        actions: {
          name: '',
        },
      }
      const res = {}
      Object.keys(cols).forEach(key => {
        const col = cols[key]
        const { width } = col
        res[key] = {
          ...col,
          cssStyle: !width
            ? ''
            : `
            --min-width-th: ${width}rem;
            --max-width-th: ${width}rem;
            `,
          tdStyle: !width
            ? ''
            : `
            --min-width-td: ${width}rem;
            --max-width-td: ${width}rem;
            `,
        }
      })
      return res
    },
    tcrud_apiData() {
      return this.$store.getters.api_get_data(this.tcrud_mutation)
    },
    tcrud_itemsDrag() {
      let res = this.tcrud_apiData?.results || []
      res = res.filter(i => i.filter_type === this.savedFilterUrlPrefix)

      const { sortKey, sortOrder } = this.tbl_sortConf
      if (sortOrder === 'desc') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      }
      return res
    },
    tcrud_items() {
      let res = this.tcrud_apiData?.results || []
      res = res.filter(i => i.filter_type === this.savedFilterUrlPrefix)

      res = getTagFilteredTableData({
        items: res,
        allTags: this.allTags,
        tagIds: this.filter.filter?.tags || [],
        anyall: this.filter.filter?.tags_anyall,
      })

      const { sortKey, sortOrder } = this.tbl_sortConf
      if (sortOrder === 'desc') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      }
      // res = [...res, ...res, ...res, ...res]
      // res = [...res, ...res, ...res, ...res]
      // res = [...res, ...res, ...res, ...res]
      // res = res.map((i, idx) => ({ ...i, id: idx }))
      // console.log(res)
      return res
    },
    tcrud_hasNext() {
      return !!this.tcrud_apiData?.links?.next || !!this.tcrud_apiData?.next
    },
    tcrud_apiCall() {
      return this.$store.getters.api_get(this.tcrud_mutation)
    },
    tcrud_loading() {
      return this.tcrud_apiCall?.loading
    },
    tcrud_error() {
      return this.tcrud_apiCall?.error
    },
    tcrud_loaded() {
      return this.tcrud_apiCall?.loaded
    },
    filter() {
      return this.$store.getters.ffsf
    },
    tcrud_params() {
      // console.log(this.filter)
      // if (!this.filter.loaded) return {}
      return {
        // ...(this.filter.params || {}),
        offset: 0,
        limit: 9999,
        // ordering: `${this.tbl_sortConf.sortOrder === 'desc' ? '-' : ''}${this.tbl_sortConf.sortKey}`,
      }
      // console.log('tcrud_params', res)
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
  watch: {
    tcrud_loaded() {
      this.$emit('loaded')
    },
  },
}
</script>
